import update from 'react/lib/update';
import * as actionConsts from './actions';
import { crewRates } from '../../../CustomPricelist/constants'
import auth from '../../../Login/authService'
const isMas = process.env.REACT_APP_title.includes("Mas");
const heading = isMas ? 'Murersvendenes Aktieselskab' : 'Christiansen & Essenbæk A/S'
const subtext = isMas ? 'Ejby Industrivej 80 \n DK-2600 Glostrup \n Tlf.: 43 43 20 00 \n mas@masas.dk \n www.masas.dk \n' : "Ejby Industrivej 80 \n DK-2600 Glostrup \n Tlf.: 88 888 203 \n info@ceas.dk \n www.ceas.dk \n"
export const initState = {
    invoiceId: '',
    loading: false,
    deleted: false,
    descr: '',
    blacklistedDailyreports: {},
    dailyreports: [],
    offersId: 'dummyId',
    offers: [],
    offersKey: Math.random(),
    othersId: 'dummyId',
    others: [],
    othersKey: Math.random(),
    activities: [],
    activitiesKey: Math.random(),
    measurements: [],
    measurementsKey: Math.random(),
    usage: [],
    usageKey: Math.random(),
    materiels: [],
    employeeHoursCalc: {
        breaks: 0,
        calcs: {},
    },
    crewKey: Math.random(),
    deliveryNotes: [],
    deliveryNotesKey: Math.random(),
    invoices: [],
    productDiscounts: [],
    bilag: [],
    dates: {
        start: '',
        end: '',
        key: Math.random()
    },
    stats: [],
    stamdata: [{}, {}, {}],
    ceas: [{
        heading,
        subtext: `${subtext} Att: ${auth.getProfile().name}`,
        editMode: false,
    }],
    sessionIdForFile: undefined,
    saved: false,
    selectedImages: {},
    selInv: false,
    prevLoading: false,
    selPriceList: 'default',
    crewRates: JSON.parse(JSON.stringify(crewRates)),
}

export default (state = initState, action) => {
    switch (action.type) {
        case 'KILL_WORKPLACE':
            return initState
        case 'INVOICE_IS_LOADING':
            return update(state, {
                loading: {
                    $set: action.status
                }
            })
        case 'PREV_IS_LOADING':
            return update(state, {
                prevLoading: {
                    $set: action.status
                }
            })
        case 'INVOICE_DESC':
            return update(state, {
                descr: {
                    $set: action.value
                },
                saved: {
                    $set: false
                }
            })
            case 'SET_INVOICE_ID':
            return update(state, {
                invoiceId: {
                    $set: action.invoiceId
                }
            })
        case actionConsts.MARK_DELETED:
            return update(state, {
                deleted: {
                    $set: action.status
                }
            })
        case actionConsts.UPDATE_BLACKLISTED_DAILYREPORTS:
            return update(state, {
                blacklistedDailyreports: {
                    $set: action.list
                },
                saved: {
                    $set: false
                }
            })
        case actionConsts.UPDATE_EMPLOYEE_CALC:
            return update(state, {
                employeeHoursCalc: {
                    $set: action.calc
                },
                crewKey: {
                    $set: Math.random(),
                },
                saved: {
                    $set: false
                }
            })
        case 'SET_INVOICE_DATEPICKER':
            return update(state, {
                dates: {
                    start: {
                        $set: action.start
                    },
                    end: {
                        $set: action.end
                    },
                    key: {
                        $set: Math.random()
                    },
                },
                saved: {
                    $set: false
                },
                blacklistedDailyreports: {}
            })
        case 'DAILYREPORTS_INVOICE_RESET':
            return update(state, {
                dailyreports: {
                    $set: []
                },
            })
        case actionConsts.SET_INVOICE_CONTENT:
            return update(state, {
                activities: {
                    $set: action.activities
                },
                activitiesKey: {
                    $set: Math.random(),
                },
                measurements: {
                    $set: action.measurements
                },
                measurementsKey: {
                    $set: Math.random(),
                },
                usage: {
                    $set: action.usage
                },
                usageKey: {
                    $set: Math.random(),
                },
                materiels: {
                    $set: action.materiels
                },
                dailyreports: {
                    $set: action.dailyreports
                },
                dailyreports2: {
                    $set: action.ds
                },
                deliveryNotes: {
                    $set: action.deliveryNotes
                },
                deliveryNotesKey: {
                    $set: Math.random(),
                },
                employeeHoursCalc: {
                    $set: action.employeeHoursCalc
                },
                crewKey: {
                    $set: Math.random(),
                },
                sessionIdForFile: {
                    $set: undefined
                },
                ceas: {
                    $set: [{
                        heading,
                        subtext: `${subtext} Att: ${auth.getProfile().name}`,
                        editMode: false,
                    }]
                },
                saved: {
                    $set: false
                }
            });
        case actionConsts.UPDATE_OFFERS:
            return update(state, {
                offersId: {
                    $set: action.offersId
                },
                offers: {
                    $set: action.offers
                },
                offersKey: {
                    $set: Math.random(),
                },
                saved: {
                    $set: false
                }
            });
        case actionConsts.UPDATE_EMPLOYEE_FUNCTION_ROW:
            return update(state, {
                employeeHoursCalc: {
                    calcs: {
                        [action.fun]: {
                            $set: action.object
                        }
                    }
                },
                crewKey: {
                    $set: Math.random(),
                },
                saved: {
                    $set: false
                }
            })
        case actionConsts.UPDATE_OFFER_ROW:
            return update(state, {
                offers: {
                    [action.index]: {
                        $set: action.offer
                    },
                },
                offersKey: {
                    $set: Math.random()
                },
                saved: {
                    $set: false
                }
            })
        case actionConsts.ADD_OFFER_ROW:
            return update(state, {
                offers: {
                    $push: [action.offer]
                },
                offersKey: {
                    $set: Math.random()
                },
                saved: {
                    $set: false
                }
            })
        case actionConsts.UPDATE_OTHERS_ROW:
            return update(state, {
                others: {
                    [action.index]: {
                        $set: action.other
                    },
                },
                othersKey: {
                    $set: Math.random()
                },
                saved: {
                    $set: false
                }
            })
        case actionConsts.ADD_OTHER_ROW:
            return update(state, {
                others: {
                    $push: [action.other]
                },
                othersKey: {
                    $set: Math.random()
                },
                saved: {
                    $set: false
                }
            })
        case actionConsts.UPDATE_USAGE:
            return update(state, {
                usage: {
                    $set: action.usage
                },
                usageKey: {
                    $set: Math.random(),
                },
                saved: {
                    $set: false
                }
            })
        case actionConsts.UPDATE_PRODUCT_DISCOUNTS:
            return update(state, {
                productDiscounts: {
                    $set: action.productDiscounts
                },
                saved: {
                    $set: false
                }
            })
        case actionConsts.UPDATE_MEASUREMENT_ROW:
            return update(state, {
                measurements: {
                    [action.index]: {
                        $set: action.measurement
                    }
                },
                measurementsKey: {
                    $set: Math.random(),
                },
                saved: {
                    $set: false
                }
            })
        case actionConsts.UPDATE_ACTIVITY_ROW:
            return update(state, {
                activities: {
                    [action.index]: {
                        $set: action.activity
                    }
                },
                activitiesKey: {
                    $set: Math.random(),
                },
                saved: {
                    $set: false
                }
            })
        case actionConsts.UPDATE_MATERIEL_ROW:
            return update(state, {
                usage: {
                    [action.index]: {
                        $set: action.materiel
                    }
                },
                usageKey: {
                    $set: Math.random(),
                },
                saved: {
                    $set: false
                }
            })
        case actionConsts.UPDATE_DELIVERY_NOTE_ROW:
            return update(state, {
                deliveryNotes: {
                    [action.index]: {
                        $set: action.deliveryNote
                    }
                },
                deliveryNotesKey: {
                    $set: Math.random(),
                },
                saved: {
                    $set: false
                }
            })
        case actionConsts.UPDATE_INVOICE_ROW:
            return update(state, {
                invoices: {
                    [action.index]: {
                        $set: action.invoice
                    }
                },
                saved: {
                    $set: false
                }
            })
        case actionConsts.ADD_INVOICE_ROW:
            return update(state, {
                invoices: {
                    $push: [action.invoice]
                },
                saved: {
                    $set: false
                }
            })
        case actionConsts.UPDATE_DELIVERY_NOTE_BILAG:
            return update(state, {
                invoices: {
                    [action.index]: {
                        bilag: {
                            $set: action.bilag
                        }
                    }
                },
                saved: {
                    $set: false
                }
            })
        case actionConsts.UPDATE_WORKPLACE_DAILYREPORT_STATS:
            return update(state, {
                stats: {
                    $set: action.stats
                },
                saved: {
                    $set: false
                }
            })
        case actionConsts.ADD_HEADINGSUBTEXT_EXTRA_INFO:
            return update(state, {
                stamdata: {
                    $push: [action.headingSubtextObj]
                },
                saved: {
                    $set: false
                }
            })
        case actionConsts.UPDATE_HEADING_EXTRA_INFO:
            return update(state, {
                stamdata: {
                    [action.index]: {
                        heading: {
                            $set: action.text
                        },
                        editMode: {
                            $set: true
                        }
                    }
                },
                saved: {
                    $set: false
                }
            })
        case actionConsts.UPDATE_SUBTEXT_EXTRA_INFO:
            return update(state, {
                stamdata: {
                    [action.index]: {
                        subtext: {
                            $set: action.text
                        },
                        editMode: {
                            $set: true
                        }
                    }
                },
                saved: {
                    $set: false
                }
            })
        case actionConsts.ADD_HEADINGSUBTEXT_CEAS:
            return update(state, {
                ceas: {
                    $push: [action.headingSubtextObj]
                },
                saved: {
                    $set: false
                }
            })
        case actionConsts.UPDATE_HEADING_CEAS:
            return update(state, {
                ceas: {
                    [action.index]: {
                        heading: {
                            $set: action.text
                        },
                        editMode: {
                            $set: true
                        }
                    }
                },
                saved: {
                    $set: false
                }
            })
        case actionConsts.UPDATE_SUBTEXT_CEAS:
            return update(state, {
                ceas: {
                    [action.index]: {
                        subtext: {
                            $set: action.text
                        },
                        editMode: {
                            $set: true
                        }
                    }
                },
                saved: {
                    $set: false
                }
            })
        case 'GET_WORKPLACE_SUCCESS': {
            let d = action.workplace.headsub.slice(0)
            d.unshift({
                heading: 'ID / Arbejdssted',
                subtext: action.workplace.name,
                editMode: false,
            })
            d.unshift({
                heading: 'Bygherre',
                subtext: action.workplace.client.name + '\n' + action.workplace.client.contact.name,
                editMode: false,
            })
            d.unshift({
                heading: 'Sag',
                subtext: action.workplace.project.number + '\n' + action.workplace.project.name,
                editMode: false,
            })

            return update(state, {
                stamdata: {
                    $set: d
                }
            })
        }
        case actionConsts.SET_SESSION_ID_FOR_FILE: {
            return update(state, {
                sessionIdForFile: {
                    $set: action.id
                }
            })
        } case actionConsts.MARK_SAVED: {
            return update(state, {
                saved: {
                    $set: true
                },
                selInv: {
                    $set: 'john'
                }
            })
        }
        case actionConsts.SET_PREV_INVOICE: {
            let state = action.invoiceState.reduxState
            let s = JSON.parse(state)
            if (!s.others) {
                s.others = []
            }
            s.invoiceId = action.invoiceState.id
            s.selInv = action.index
            return s
        }
        case actionConsts.UPDATE_SELECTED_IMAGES: {
            return update(state, {
                selectedImages: {
                    $set: action.images
                },
                saved: {
                    $set: false
                }
            })
        }
        case actionConsts.SELECT_PRICELIST_ACTION: {
            return update(state, {
                selPriceList: {
                    $set: action.id
                }
            })
        }
        case actionConsts.UPDATE_CREW_RATES: {
            return update(state, {
                crewRates: {
                    $set: action.crewRates
                }
            })
        }
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/Workplace/Invoice/reducer.js